import React from "react";

const ErrorPage = () => {
  return <div>Error 404. Page not found</div>;
};

export default ErrorPage;
